import { Chip, Typography, Box, Card, Stack } from "@mui/material";
import {
  spacing,
  colors,
  typography,
} from "../../../../../../../../../assets/styles/tokens";
import type { RevenueRow } from "./PlayerValueTable";
import PlayerValueTable from "./PlayerValueTable";

const TotalIncomeTableHeadings = {
  metric: "",
  actual_target: "Actual / Target",
  RR: "RR",
  PRR: "PRR",
};

const TotalIncomeTableRows: RevenueRow[] = [
  {
    cron_id: "1",
    rrType: "success",
    metric: "CPA PV",
    actual_target: "$168 / $161",
    RR: "$375,119",
    PRR: "$168",
  },
  {
    cron_id: "2",
    rrType: "warning",
    metric: "RS PV",
    actual_target: "$99 / $223",
    RR: "-$5",
    PRR: "$111",
  },
];

export default function PlayerValue() {
  return (
    <Card
      sx={{
        p: spacing.Spacing.lg.$value,
        borderRadius: spacing.Radius.xl.$value,
        boxShadow:
          "0px 1px 2px rgba(16,24,40,0.06), 0px 1px 3px rgba(16,24,40,0.1)",
      }}
    >
      {/* HEADER */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-end"
        mb={2}
      >
        <Box>
          <Typography
            sx={{
              fontSize: typography.Size.Text.sm.$value,
              fontWeight: 500,
              color: colors.GrayLightMode[600].$value,
            }}
          >
            PV
          </Typography>

          <Typography
            sx={{
              fontSize: typography.Size.Text.xl.$value,
              fontWeight: 600,
              color: colors.GrayLightMode[900].$value,
              mt: spacing.Spacing.xs.$value,
            }}
          >
            $1,093,140
          </Typography>

          <Typography
            sx={{
              fontSize: typography.Size.Text.sm.$value,
              color: colors.GrayLightMode[600].$value,
              mt: spacing.Spacing.xxs.$value,
            }}
          >
            out of{" "}
            <Box
              component="span"
              fontWeight={600}
              color={colors.GrayLightMode[900].$value}
            >
              $399
            </Box>
          </Typography>
        </Box>

        <Stack spacing={spacing.Spacing.sm.$value} alignItems="flex-end">
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography color={colors.GrayLightMode[700].$value}>RR</Typography>
            <Chip
              label="105.65%"
              sx={{
                bgcolor: colors.Success[50].$value,
                color: colors.Success[700].$value,
                fontWeight: typography.Font_weight.Semibold.$value,
                borderRadius: spacing.Radius.sm.$value,
              }}
            />
          </Stack>

          <Stack direction="row" spacing={1} alignItems="center">
            <Typography color={colors.GrayLightMode[600].$value}>
              PRR
            </Typography>
            <Typography
              fontWeight={600}
              color={colors.GrayLightMode[900].$value}
            >
              $1,561,629
            </Typography>
          </Stack>
        </Stack>
      </Stack>

      {/* TABLE */}
      <PlayerValueTable
        TotalIncomeTableHeadings={TotalIncomeTableHeadings}
        TotalIncomeTableRows={TotalIncomeTableRows}
      />
    </Card>
  );
}
